/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Alert16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 11.6A1.2 1.2 0 108 14a1.2 1.2 0 000-2.4zM8 2a1.2 1.2 0 00-1.2 1.2v6a1.2 1.2 0 002.4 0v-6A1.2 1.2 0 008 2z"
            fill={vars.bdlGray50}
        />
    </AccessibleSVG>
);

export default Alert16;
